import React, { useState } from 'react';
import './SalesExport.css';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
const TODAY = new Date().toISOString().split('T')[0];

function SalesExport() {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [exporting, setExporting] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);

  const handleExport = async (e) => {
    e.preventDefault();
    setStatusMessage(null);

    if (!dateFrom || !dateTo) {
      setStatusMessage({ type: 'error', text: 'Please select both From and To dates' });
      return;
    }
    if (dateTo < dateFrom) {
      setStatusMessage({ type: 'error', text: '"To" date must be on or after "From" date' });
      return;
    }

    setExporting(true);

    try {
      const params = new URLSearchParams({ date_from: dateFrom, date_to: dateTo });
      const response = await fetch(`${API_URL}/sales/export?${params}`);

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || 'Export failed');
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `sales_${dateFrom}_${dateTo}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);

      setStatusMessage({ type: 'success', text: 'Export downloaded successfully' });
    } catch (err) {
      setStatusMessage({ type: 'error', text: err.message });
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="sales-export">
      <h2>Export Sales</h2>
      <p className="sales-export-subtitle">Download sales data as an Excel spreadsheet</p>

      <form className="export-form" onSubmit={handleExport}>
        <div className="export-form-row">
          <div className="export-form-group">
            <label htmlFor="exportDateFrom">From</label>
            <input
              id="exportDateFrom"
              type="date"
              value={dateFrom}
              max={TODAY}
              onChange={e => setDateFrom(e.target.value)}
              required
            />
          </div>
          <div className="export-form-group">
            <label htmlFor="exportDateTo">To</label>
            <input
              id="exportDateTo"
              type="date"
              value={dateTo}
              max={TODAY}
              onChange={e => setDateTo(e.target.value)}
              required
            />
          </div>
        </div>

        {statusMessage && (
          <div className={`export-message ${statusMessage.type}`}>
            {statusMessage.text}
          </div>
        )}

        <button type="submit" className="export-btn" disabled={exporting}>
          {exporting ? 'Exporting...' : 'Download Excel'}
        </button>
      </form>
    </div>
  );
}

export default SalesExport;
